import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

interface PropsType {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSortKeyword: React.Dispatch<React.SetStateAction<string>>;
  setSortKeywordLabel: React.Dispatch<React.SetStateAction<string>>;
  sortKeyword: string;
  setSortDirection: React.Dispatch<React.SetStateAction<string>>;
  sortDirection: string;
  setIsSortIcon: React.Dispatch<React.SetStateAction<boolean>>;
  btnSortRef: any;
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

export default function ProductSortLayer({
  setIsModal,
  setSortKeyword,
  sortKeyword,
  setSortKeywordLabel,
  setSortDirection,
  sortDirection,
  setIsSortIcon,
  btnSortRef,
}: PropsType) {
  const sortItem = [
    { label: '추천순', value: 'RECOMMENDATION', desc: 'DESC' },
    { label: '최신순', value: 'SALE_YMD', desc: 'DESC' },
    { label: '인기순', value: 'POPULAR', desc: 'DESC' },
    { label: '가격순', value: 'DISCOUNTED_PRICE', desc: 'DESC' },
  ];
  const productSortLayerRef = useRef<any>(null); // 모달 레이어 ref

  const closeModal = () => {
    setIsModal(false);
  };

  // 모달 외부 클릭시 닫기
  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (
        productSortLayerRef.current &&
        !productSortLayerRef.current.contains(e.target) &&
        btnSortRef.current &&
        !btnSortRef.current.contains(e.target)
      ) {
        setIsModal(false);
        setIsSortIcon(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [productSortLayerRef]);

  return (
    <ModalWrap ref={productSortLayerRef}>
      <ModalBox>
        <ModalBody>
          <SortItemWrap>
            {sortItem.map((el: any) => {
              return (
                <>
                  <SortItem key={el.value}>
                    <CustomRadio>
                      <input
                        type="radio"
                        value={el.value}
                        name="radioBtn"
                        id={el.label}
                        onChange={() => {
                          setSortKeyword(el.value);
                          setSortKeywordLabel(el.label);
                          setSortDirection(el.desc);
                          setIsSortIcon(false);
                          closeModal();
                        }}
                        checked={sortKeyword === el.value && sortDirection === el.desc}
                      />
                      <label
                        htmlFor={el.label}
                        className={sortKeyword === el.value && sortDirection === el.desc ? 'on' : ''}
                      >
                        {el.label}
                      </label>
                      <span className="checkmark"></span>
                    </CustomRadio>
                  </SortItem>
                </>
              );
            })}
          </SortItemWrap>
        </ModalBody>
      </ModalBox>
    </ModalWrap>
  );
}

interface typeProps {
  closing?: boolean;
}
export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 135px;
  height: 100%;
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 10;
`;

export const ModalBox = styled.div`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 8px;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 16px;
  top: 0;
  padding: 6px 32px 6px 16px;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.1);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  align-items: center;
`;

export const ModalBody = styled.div``;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const ModalTitle = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
`;

export const SortItemWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
`;

export const SortItem = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  align-items: flex-start;
`;

export const CustomRadio = styled.div`
  width: 100%;
  display: inline-block;
  cursor: pointer;
  position: relative;
  padding: 10px 0;
  font-size: 16px;
  line-height: 20px;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  label {
    width: 100%;
    color: var(--colGray5);
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;
    &.on {
      color: var(--colBlack);
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
    }
  }

  /* 체크되었을 때 배경색과 아이콘 색을 변경합니다. */
  &:hover input ~ .checkmark {
    background-color: var(--colWhite);
  }

  input:checked ~ .checkmark {
    background-color: var(--colBlack);
  }

  .checkmark {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid var(--colGray3);
    background-color: var(--colWhite);
    border-radius: 50%;
  }

  /* 체크되었을 때 아이콘을 보여줍니다. */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }
  input:checked ~ .checkmark {
    border: none;
  }
  input:checked ~ .checkmark:after {
    display: block;
  }

  /* 체크되었을 때 아이콘 스타일을 지정합니다. */
  .checkmark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`;

const RadioContainer = styled.div`
  margin-bottom: 15px;
`;
